<template>
    <transition name="slide-up">
        <div
            v-if="count > 0 && !hidden"
            class="selection-footer"
        >
            <div class="selection-footer-left">
                <div class="selection-footer-info">
                    <slot name="info">
                        <span class="selection-footer-count">
                            {{ count }}
                        </span>

                        {{ itemLabel }}
                    </slot>
                </div>

                <div
                    v-if="$slots.summary"
                    class="selection-footer-summary"
                >
                    <slot name="summary" />
                </div>
            </div>

            <div class="selection-footer-right">
                <slot name="actions" />
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'SelectionFooter',

    props: {
        count: {
            type: Number,
            default: 0
        },

        itemLabel: {
            type: String,
            default: ''
        },
        hidden: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style lang="scss" scoped>
.selection-footer {
    position: fixed;
    left: 50%;
    bottom: 14px;
    transform: translateX(-50%);
    z-index: 999;

    width: calc(100% - 32px);
    max-width: 70vw;

    background: #22252a;
    border-radius: 10px;

    padding: 8px 16px;

    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;

    box-shadow:
        0 8px 24px rgba(0, 0, 0, 0.24),
        0 2px 8px rgba(0, 0, 0, 0.16);
}

.selection-footer-left {
    display: flex;
    align-items: center;
    gap: 16px;

    color: #ffffff;
}

.selection-footer-info {
    font-size: 0.74rem;
    color: rgba(255, 255, 255, 0.68);
}

.selection-footer-count {
    font-size: 0.9rem;
    font-weight: 700;
    color: #ffffff;
}

.selection-footer-summary {
    font-size: 0.8rem;
    color: rgba(255, 255, 255, 0.84);
}

.selection-footer-summary ::v-deep strong {
    color: #ffffff;
    font-size: 0.9rem;
}

.selection-footer-right {
    display: flex;
    align-items: center;
    gap: 12px;
}

.selection-footer-right ::v-deep .ant-btn {
    height: 34px;
    padding: 0 16px;

    display: flex;
    align-items: center;
    gap: 6px;

    border: 0;
    border-radius: 8px;

    

    font-size: 0.8rem;
    font-weight: 600;

    transition: all 0.2s;
}

.selection-footer-right ::v-deep .ant-btn:hover,
.selection-footer-right ::v-deep .ant-btn:focus {
    background: #ff5a47;
    color: #ffffff;
}

@media (max-width: 768px) {
    .selection-footer {
        flex-direction: column;
        align-items: stretch;
        gap: 16px;
    }

    .selection-footer-left {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }

    .selection-footer-right {
        width: 100%;
        flex-wrap: wrap;
    }

    .selection-footer-right > * {
        flex: 1;
    }
}
</style>